// version: 1.0.0
// /* eslint-disable prefer-regex-literals */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable @typescript-eslint/explicit-function-return-type */
// /* eslint-disable @typescript-eslint/strict-boolean-expressions */
// /* LAYOUT DEFAULT COMPONENT
//    ========================================================================== */
// import React, { useState } from 'react'
// import { Outlet } from 'react-router-dom'

// import Header from '../layouts/navbar/navbar'
// import Sidebar from '../layouts/sidebar/sidebar'

// function LayoutDefault () {
//   const [sidebarOpen, setSidebarOpen] = useState(false)

//   return (
//     <div className="flex h-screen overflow-hidden">
//       {/* Sidebar */}
//       <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

//       {/* Content area */}
//       <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
//         {/* Header */}
//         <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

//         {/* Main content */}
//         <main className="flex-1 p-4 sm:p-6 lg:p-8">
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   )
// }

// export default LayoutDefault

// // version: 1.2.0 - dùng navbar và sidebar từ version 1.0.0
// /* eslint-disable prefer-regex-literals */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable @typescript-eslint/explicit-function-return-type */
// /* eslint-disable @typescript-eslint/strict-boolean-expressions */
// /* LAYOUT DEFAULT COMPONENT
//    ========================================================================== */
// import React, { useState } from 'react'
// import { Outlet } from 'react-router-dom'

// import Header from '../layouts/navbar/navbar'
// import Sidebar from '../layouts/sidebar/sidebar'
// function LayoutDefault () {
//   const [sidebarOpen, setSidebarOpen] = useState(false)

//   return (
//     <div className="flex flex-col h-screen overflow-hidden"> {/* Changed to flex-col */}
//       {/* Header */}
//       <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

//       {/* Main content area with Sidebar */}
//       <div className="relative flex flex-1 overflow-hidden"> {/* Added relative for positioning context */}
//         {/* Sidebar */}
//         <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

//         {/* Page content */}
//         <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 lg:p-8">
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   )
// }
// export default LayoutDefault

// // version: 2.0.0
// /* eslint-disable @typescript-eslint/explicit-function-return-type */
// // /* eslint-disable prefer-regex-literals */
// // /* eslint-disable @typescript-eslint/no-unused-vars */
// // /* eslint-disable @typescript-eslint/explicit-function-return-type */
// // /* eslint-disable @typescript-eslint/strict-boolean-expressions */
// // /* LAYOUT DEFAULT COMPONENT
// //    ========================================================================== */
// import React, { useState } from 'react' // Added useEffect
// import { Outlet } from 'react-router-dom'

// import Header from '../layouts/navbar/navbar'
// import Sidebar from '../layouts/sidebar/sidebar'
// function LayoutDefault () {
//   const [sidebarOpen, setSidebarOpen] = useState(false)
//   // Lift sidebarExpanded state here
//   const storedSidebarExpanded = typeof window !== 'undefined' ? localStorage.getItem('sidebar-expanded') : null
//   const [sidebarExpanded, setSidebarExpanded] = useState(
//     storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true'
//   )

//   return (
//     <div className="flex flex-col h-screen overflow-hidden"> {/* Changed to flex-col */}
//       {/* Header */}
//       <Header
//         sidebarOpen={sidebarOpen}
//         setSidebarOpen={setSidebarOpen}
//         sidebarExpanded={sidebarExpanded}
//         setSidebarExpanded={setSidebarExpanded}
//       />

//       {/* Main content area with Sidebar */}
//       <div className="relative flex flex-1 overflow-hidden"> {/* Added relative for positioning context */}
//         {/* Sidebar */}
//         <Sidebar
//           sidebarOpen={sidebarOpen}
//           setSidebarOpen={setSidebarOpen}
//           sidebarExpanded={sidebarExpanded}
//           setSidebarExpanded={setSidebarExpanded} // Pass down setSidebarExpanded
//         />

//         {/* Page content */}
//         <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 lg:p-8">
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   )
// }
// export default LayoutDefault

// version: 2.1.0 - fix bug tồn ở version 2.0.0: ở màn hình iphone 5 hình ảnh avatar ở navbar bị mất
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// /* eslint-disable prefer-regex-literals */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable @typescript-eslint/explicit-function-return-type */
// /* eslint-disable @typescript-eslint/strict-boolean-expressions */
// /* LAYOUT DEFAULT COMPONENT
//    ========================================================================== */
import React, { useState } from 'react' // Added useEffect
import { Outlet } from 'react-router-dom'

import Header from '../layouts/navbar/navbar'
import Sidebar from '../layouts/sidebar/sidebar'
function LayoutDefault () {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  // Lift sidebarExpanded state here
  const storedSidebarExpanded = typeof window !== 'undefined' ? localStorage.getItem('sidebar-expanded') : null
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true'
  )

  return (
    <div className="flex flex-col h-screen w-screen overflow-x-hidden"> {/* MODIFIED: Added w-screen and changed to overflow-x-hidden */}
      {/* Header */}
      <Header
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        sidebarExpanded={sidebarExpanded}
        setSidebarExpanded={setSidebarExpanded}
      />

      {/* Main content area with Sidebar */}
      <div className="relative flex flex-1 w-full overflow-hidden"> {/* ADDED: w-full to ensure it takes full width of parent */}
        {/* Sidebar */}
        <Sidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          sidebarExpanded={sidebarExpanded}
          setSidebarExpanded={setSidebarExpanded} // Pass down setSidebarExpanded
        />

        {/* Page content */}
        <main className="flex-1 w-full overflow-y-auto overflow-x-hidden p-2"> {/* ADDED: w-full for explicitness */}
          <Outlet />
        </main>
      </div>
    </div>
  )
}
export default LayoutDefault
